module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer025"
    }
  }, [_c('p', {
    staticClass: "chapter-number-only",
    attrs: {
      "id": "_idParaDest-5",
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("Chapter 2")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Ralph Hillerman was one of those men who would look as if he was in his late fifties until he was about seventy-five, when his true age would begin to show. He was sixty-four now, but he was a vigorous and active sixty-four. Considering that his father had still been driving a car when he was eighty-six, Ralph Hillerman was a good example of the importance of genes. He had been running his own heating-oil business for the past thirty-five years, and he had built it into a rather successful enterprise. He had three children, all college graduates and professionals: two lawyers and one dentist. He and his wife lived in a large two-story stone-faced house on Pine Hill Drive in South Fallsburg, one of the more expensive neighborhoods in the township.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Cynthia had known him all her life. She remembered that her father had liked him because he thought he was a clever businessman, serious-minded and shrewd. He was a pleasant enough man, polite and soft of manner. Like her father, Ralph Hillerman had an air of respectability about him. He was always dressed in a jacket and a tie and always cleanly shaven. Although Cynthia had never been to his house, she had heard that his wife was meticulous and even now spent a large part of her day cleaning and polishing. With all their money, they never hired a housekeeper, even when the children were all there.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“My wife would only clean up after her,” he told Cynthia once. He joked about it, but it was obvious to Cynthia that Ralph Hillerman’s wife had a strong influence on him. He kept his office neat and clean, and although he drove an eight-year-old car, it looked practically brand-new. She loved getting into it. The cloth seats were spotless, and the inside of the car carried the scent of an expensive men’s cologne.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I can’t believe the good luck,” Ralph said after they pulled away from the Palmer Agency. Cynthia had gone out to wait for him. Their building was still surrounded by undeveloped land and the fall colors were at their peak. Besides that, they were experiencing some of the famous Indian summer for which this part of the Catskills was famous. Mornings were brisk and cool, but the afternoons warmed the day into a kinship with the summer past. At night the temperatures dropped again, but usually remained ten degrees or so above freezing. In the morning the heavy dew would make the grass glisten as though covered with ice.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("To Cynthia this was the best time of the year to advertise and sell a house and property. The area was deceptively beautiful because it was quiet and pretty. The summer tourist season was over, and any newcomer wouldn’t be as aware of the way the area changed during the busy resort months. Streets were sparsely traveled; stores looked quaint and quiet; nature looked unabused. There was a picturesque, storybook quality to the area that recommended it to prospective real estate customers.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I told my wife,” Ralph went on, “that the Rose Hill House would probably end up like so many of the other old tourist places, an eventual eyesore.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Cynthia smiled. She hadn’t been able to get a word in. The sale had made him ebullient, bringing even more color into his healthy-looking crimson cheeks. His robustness was infectious, and she was able to put aside her heavy thoughts for a moment.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I can’t envision the Rose Hill House an eyesore.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, believe me, it wouldn’t take long. We’ve already lost control of a good part of the grounds. I don’t know if you’re old enough to remember how my father kept that place. If the sun didn’t go down he’d never stop. Thank God he can’t realize how bad it has become.” He paused and looked at her. “Heck, I’m goin’ on and on here, and I really haven’t properly thanked you. You’re a damn good businesswoman, Cynthia, damn good.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Thank you, but this was one of those times the product sold itself. It just happened to be what these people were looking for.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You’re modest, but I know you had a lot to do with hooking them.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She laughed, and a few minutes later they pulled into Liberty, one of the busier villages in the county. Because of the fine weather, there were more people than usual on the streets. She felt a liveliness in the air, and she realized she was proud of herself for what she had done. It was an accomplishment.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Ralph took her to Chucky’s, a restaurant on Main Street. It was a small place, but it was well-known for its pot roast sandwich. However, Cynthia wasn’t very interested in food. She ordered a salad and a club soda. She had always had a slim, attractive figure with a narrow waist and hips. Her posture and her air of confidence gave her a model’s elegance. Some people, especially envious women, characterized her demeanor as arrogant, part of what Jason called being Palmeresque.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As soon as they had ordered, Ralph wanted to know all about the Bloomfields. Cynthia had expected that. It was part of her theory about the sale of houses. Owners who weren’t in desperate financial straits acted as though they were handing one of their children over to a new family. In their own minds they were trying to imagine how this new family would fit in their surroundings. Some people wore their homes like clothing; it was difficult to think of someone else being warmed and sheltered in it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, they don’t sound like your typical rooming-house owners,” Ralph concluded. “They’ll probably turn the place into a Club Med.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Cynthia laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, I don’t know, Ralph. You really can’t tell about some people.” He grunted, but he was convinced his own predictions would come true. Cynthia thought she would take advantage of the pause in the conversation. She told him about the mess his father had made with the papers in his room and the discovery of the newspaper article.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He had that? I didn’t think my mother permitted any copies to be in the house. I never saw it—that’s for sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It was a forbidden story. I was just a teenager when it happened, but I remember my mother putting the fear of God in me about it. It worked because I pushed it out of my thoughts all these years.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Why did she do that?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Why?” He sat back and smiled as though he could see it all before him. She envied the obviously good memories. “We were in the heyday of good seasons then. Our reputation was great. The grounds were gorgeous; my mother was a fabulous cook, and the house was kept spick-and-span. Don’t forget the railroad was encouraging tourism in the area to stimulate its passenger business. My father was even talking about another expansion. You know,” he said, sitting forward, “I often think we might have become a major Catskill resort like the Concord or Grossingers, if we’d had the right capital investment and some of the luck.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Maybe you should have stayed with it.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Naw, naw, I could see the future. I knew what was coming.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He was quiet for a moment, and she wondered if that were true—if he had been able to foresee and predict. It made her think of the story again.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“But getting back to this news article. Your mother wanted you to forget it?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“People are funny about things like that. You know what I mean. What’s that place you told me no one can sell because of the double suicide that occurred in it?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“The Martin house.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Right, right. Well, you can imagine what a brother murdering his sister at our place would do to the reputation of the Rose Hill House. We weren’t to blame of course; but you do get tainted.” He smiled and then laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What’s so funny?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“My grandmother, my father’s mother, was still alive then. She was from Hungary and always talked about the gypsies and the evil eye and that sort of thing. She told me if you talked about the dead, especially those who died violent deaths, you could stir up their spirits. Anyway, any mention or even the vaguest reference to the murder by anyone in the Rose Hill House was taboo, worse than a string of four-letter words. I said something about it once to a kid, son of a tourist family, years later, and it got back to my mother. She put my father on me, and he beat the livin’ bejesus out of me. I was about seventeen at the time, too. My father was a strong man. Why, when he got mad …”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“But you’re not afraid to talk about it now, are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No. I just don’t remember that much anymore. Honest. I guess I did what they call repression. After what my grandmother had told me, I usta have nightmares about it once in a while.” He smiled at the memory and sat forward. “What did the Bloomfields have to say about it? How did they react?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“They don’t know about it. I told Mrs. Marshall not to say anything, either, and she said she wouldn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh.” He thought a moment. “Then maybe we shouldn’t rile it all up again. At least not until the sale is finalized.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He bit down softly on his lower lip, as though to prevent himself from uttering another word, and she felt a terrible sense of disappointment.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You’re right, but I honestly believe if these people knew about it they’d think it was more reason to buy the house. They’re intrigued with its history; they think it has character. Stories like this one are fascinating to people nowadays.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’m sure they are.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“There’s no reason why we can’t talk about it. As much of it as you can remember, that is.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I suppose not. What do you want to know?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She pulled the news clipping from her pocketbook.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I kept this. I hope you don’t mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“My, you are interested, aren’t you? What makes an old story like this one so special? Turn on your television set, pick up a newspaper tomorrow … murders like that one happens every hour on the hour these days.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I guess you don’t remember what Karla Hoffman looked like, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No. I didn’t pay much attention to the adult guests in those days and as I said …”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She pushed the clipping across the table, with the photo facing up. He looked at it and then took it into his hands to inspect it even closer. Then he looked at Cynthia and smiled with a slight nod.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Think she looks like you, is that it?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Doesn’t she?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He compared her to the picture again and shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“There’s quite a resemblance, but your family background and hers don’t …”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No, there’s no possibility of our being related. At least I don’t see how there could be.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“They say we all came from the same parents.” His smile widened, but she could see that the comparison of faces didn’t strike him as being a very significant fact. “So, what about it, Cynthia? She looks like you. What does that mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t know exactly.” She thought for a moment. When someone as fatherly as Ralph Hillerman questioned her now, she did wonder if she were acting silly. “I just have this … this need to know more about her and what happened,” she said slowly, like one in a dream. “Don’t laugh,” she added, “but it’s almost … mystical.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’ll be damned.” He sat back, the half-smile on his face again as he considered the picture more seriously. She could see he was trying to revive his memories. The waitress brought them their food before he spoke, but she could almost hear his thoughts—he was wondering if she weren’t a little wacko.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Tell me what you remember. Please.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, if I strain my memory …” He looked at the article again. “No one knew there was any such animosity between them. They seemed like a quiet threesome.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Threesome?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Her brother always came along with them. But there wasn’t anything wrong with that. My mother wouldn’t have rented them rooms if she suspected any problems. Believe me. Actually, now that I recall, they were quite respectable. They owned a small but growing clothing factory in the city. Not a sweatshop, a quality place.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“So what went wrong? What happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t really know. One night there was some argument and the knifing. I slept through the whole thing. I didn’t even hear the police arrive or anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He took a large bite of his sandwich. Cynthia had been eating her salad as she listened to him attentively, but she took the opportunity to finish what more of it she wanted when he began to eat. She was a great deal hungrier for the remainder of the story. He sat back, thinking again.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I guess of the three of them, my mother liked the brother the least. She got that from my grandmother who had a way of sizing up the guests. Like a gypsy,” he added, “with some kind of crystal ball, she would make her pronouncements about people, her predictions.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Do you think it’s possible that her husband might still be alive?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Couldn’t tell you that. Like I said, once it was over, the story was drummed out of my consciousness. I wouldn’t ask any questions about them. Once the excitement ended I lost interest anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He’d be about seventy-five,” Cynthia said, looking at the article.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It’s certainly possible.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“But you don’t remember much about Karla?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No, not really. I certainly never connected her face with yours until you put the picture right in front of me. I mean we’re talking fifty years ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I know,” she said. He continued to eat his sandwich, but he ate a little faster. Cynthia looked as though she might cry. “Is there anyone else around who might remember her?” she asked quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What are you after here?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t know for sure, but I do know I have to satisfy that need to know as much about her as I can.” He stopped chewing and stared at her. “Indulge me, Ralph. Then you won’t have to give me a bonus for selling your property so quickly. This will be my bonus.” He laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“All right. Let’s see. Sure. Sammy Segar was a policeman then. He’s still around, lives with his son and daughter-in-law in Devine Corners. He’d a hafta have been in on it. I suppose you go see him; he loves to talk about the old times.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Thanks. Do you mind if I keep the article?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No. That’s okay. I’ve got a number of old things up there of some value, I suppose. My mother had a lot of great old pictures. What I’ll do is go up to the house during the next few days and sort through some of the stuff. I’ll probably donate a good deal of it to the county museum in Hurleyville.” He started to eat again and stopped. “Hey now, there’s a place for you to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“The county museum? But this wasn’t a famous case or anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No, but they’ve got those stacks and stacks of old news­papers in their library. They go back to the 1800s.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Of course,” she said. “And I’m friendly with Miss Weintraub, the county historian. I should have thought of that.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Surprised you didn’t. Maybe you’re not as hot over this as you think you are.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, I’m hot enough about it,” she said, smiling. She put the article back into her pocketbook. “I wonder,” she said, “if, during his more clear-minded moments, your father would remember much about the whole affair. For a moment there today, he seemed almost as though he wanted to say something.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“My guess is that even if he could remember anything, he wouldn’t talk. My mother’s influence is too strong, even now.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Would you mind if I tried to talk to him about it sometime?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well …” He was surprised at the anxiety in her face. “It’s okay with me, but you’d better remember what my grandmother told me.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I forgot already.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Stirrin’ up the spirits.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, yes, yes. I’ll be careful about that.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Who knows,” he said, “it might be too late already.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He had to laugh emphatically to let her know he was only joking.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Jason came to her office only moments after she returned from her lunch with Ralph Hillerman. She suspected that her brother had asked Judy to signal him as soon as she had come back. Cynthia didn’t like to think of herself as being paranoid, but she was feeling spied upon more and more lately. Jason made great demands on the staff. They sensed his expectations and responded with the kind of loyalty that nurtured his power over them. Cynthia felt his stamp on everyone. There was an air of perfection about everything, even the smallest of tasks. Phones were always answered properly; messages were always taken accurately and correctly. She couldn’t help resenting it. Sometimes she felt as though she were surrounded, deliberately kept off to the side like some poor relation, tolerated but not really respected, a shadow of Jason left to linger in a corner.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Sometimes Jason moved like a shadow. He spoke softly and carried himself with a quiet grace she often envied. Recently, however, her brother’s eyes displayed an uneasiness that had attracted her interest. He seemed distracted and too thoughtful. Whenever she spoke to him she felt he was looking through her, beyond her, around her. Afterward she would be left with an eerie, cold feeling, as though she had just had a conversation with a corpse.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As usual Jason was impeccably dressed in his coordinated Pierre Cardin brown jacket, tie, slacks and shoes. His ring, their father’s ring, the flat black onyx with the diamond in the center, glittered on his fourth finger. It had been Carl Palmer’s pinky ring, but Jason’s hands were so much smaller than his father’s.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Jason’s hair, the same dark brown shade of Cynthia’s natural color, looked as though he had stopped at his barber’s for a comb-out. She suspected him of doing that occasionally anyway. Ever since she could remember, Jason was terribly concerned about his appearance and his personal possessions. While other mothers were continually after their children to pick up their things or clean up their rooms, Jason was after his mother to improve on the way his room was cleaned and his things were handled. Cynthia recalled the hours he would spend in his room organizing his socks and underwear, folding his shirts and pants and shining his shoes. He hated to see anything out of place.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Because of his fastidiousness he was often ridiculed by other students in school, but none of that seemed to matter to him or bother him. Cynthia had always admired her brother for his ability to turn off people when he wanted to or when they were somehow distasteful to him. Jason often based everything on his first impressions, and he rarely changed his opinion of someone, especially negative opinions of her friends.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Even so, they had few confrontations. He, like Stephen, shied away from doing any verbal battle with her. They usually retreated, sidestepped, apologized or rationalized. She had begun to get the feeling that they had conspired to “handle” her, secretly priding themselves on their success. It was frustrating, but she couldn’t point to any one thing and pounce.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Studying the photograph and realizing the similarities between herself and Karla Hoffman had made Cynthia more aware of the similarities between herself and her brother Jason. Looking at him now, she imagined that if she didn’t pluck her eyebrows, they would be like his. They had identical noses, and both of them had their mother’s soft, thin mouth. Jason’s cheekbones weren’t as pronounced as hers and his eyes weren’t set as deeply, but they often had the same look.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Their differences were underlined in the way Jason’s face changed expression and in the way he held his mouth. Jason’s smile was often sardonic; his thoughtful look more intense, even hypnotic. When he was angry his face was all eyes; they would widen and burn with a catlike fury. Opponents would feel they were about to be clawed, which was most ironic, for Jason was not a very physical person. He disliked men who patted and touched one another incessantly, “like adolescent boys in school locker rooms.” Nothing made him cringe as much as a man putting his arm around his shoulders during a discussion. His handshake was quick and smooth; he’d slip his fingers in and out of someone’s palm so fast that the person wasn’t sure they had really touched. If a man held his hand too long, his shoulders would rise and he would turn away as if to say, “I refuse to look or to speak to you until you release me.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Only Stephen could violate these pet peeves of Jason’s, but he didn’t violate them often. Stephen was very sensitive to Jason’s moods, even more sensitive than he was to hers, Cynthia thought. It bothered her, but she justified it by thinking that perhaps it was because she wasn’t as finicky as Jason and didn’t take out her bad moods on others the way Jason often did. Anyway, she thought, Stephen and Jason had been working together so long and were so intent on their similar purposes that it was understandable Stephen would be so in tune with Jason. She resented it only because he wasn’t in tune enough with her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Stephen tells me that both congratulations and an apology are called for,” Jason said. He closed the door softly behind him and approached her desk.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I wish you would reverse the order of the two.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He laughed. Jason always has perfect posture, she thought, but smiled to herself recalling a vivid dream she had once. In it Jason was a peacock.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It wasn’t Stephen’s fault, it was mine. We don’t mean to neglect you. I was so involved in this idea that I didn’t think to talk to you about it. Stupid of me because here we obviously have a resident expert when it comes to real estate,” he said. He sounded sincere, but that made her even more resentful. He never lost his cool, never lost the advantage.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You two always do such a nice job of apologizing for one another,” she said. He smiled and waved his hand backward, a characteristic gesture that looked more as if he was chasing away flies than anything else. It was his way of signaling the end to a discussion of that subject. Arrogant and usually annoying, she thought.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He sat in the chair just to the right of the front of her desk and crossed his legs.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You must tell me how you pulled off this sale. An old tourist house like the Rose Hill … it’s something of an accomplishment, Cyn. Once this gets out you’re going to have triple the listings.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“There’s nothing to tell. The right customers came at the right time.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“False modesty? Come on. You’re a Palmer. You’re good at whatever you do. Dad would be proud of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Bullshit, Jason. He’d be shocked. He never had any faith in my business abilities.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Jason laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, Dad had some old-fashioned ideas good for his time. Anyway, Ralph Hillerman must be ecstatic. You took some load off his shoulders. I was thinking about contacting him about a partnership we want to form involving a parking lot in Manhattan. Maybe he’ll be interested now. It looks like a good investment.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What parking lot? Where?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh hell, there I go again. Carl Samuels wrote me about this. I’ll show you his letter. If you have time later, come in and peruse that and the prospectus on this time-sharing investment in Florida. I’d like to hear your impressions.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She let herself relax because he did sound sincere. Suddenly that saddened her, however. Why was it that her brother could be more understanding than her husband when it came to her feelings? They weren’t as intimate. It made her wonder about the bond of family and the way Jason always talked about being Palmeresque. Maybe there was something to it; maybe there were facets of herself that she never realized. Maybe she was more like Jason than she cared to be. Or maybe … maybe he was more like her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("These thoughts brought her quickly back to Karla Hoffman. If she had had such a dramatic reaction when she was confronted with the picture of the murdered woman, what would be Jason’s reaction? Impulsively she pulled the old news clipping from her purse.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I want to show you something I found up at the Rose Hill House. Old man Hillerman had thrown his papers out, and the woman who takes care of him handed me this.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She put it on her desk, and he leaned forward to pick it up. He read it and looked at the picture. She watched his face as he did so, but she detected very little change in his expression. Finally he shrugged and put it back on her desk.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Obviously you are impressed with the physical resemblance.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Aren’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I never told you this, but when I was in college I met a girl who looked a lot like you. Actually I got to know her well. It was during my senior year. Of course, she wasn’t at all like you. She was what people today refer to as an ‘airhead,’” Jason said. She saw a new look in his eyes, a cross between anger and hurt. “But the physical resemblance was strong.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Are you saying I have a common face? Because the same would apply to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No, it’s not that,” he said, snapping out of whatever memory made his eyes glisten. “I’m just trying to tell you that as remarkable as this might seem to you now, it’s really no big deal. The world is full of people who look somewhat alike.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t agree. I find it intriguing, and I want to find out more about her, more about the story.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“How you waste your time is your own business, I guess.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Exactly.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Did you show this to Stephen?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No. And I don’t intend to,” she added quickly. “I know what he’ll say—he’ll just agree with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You judge him too harshly, Cyn. He’s a lot more sympathetic than you think. He brags about you incessantly at meetings. Actually I find it sickening at times.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Couldn’t tell that by me,” she said dryly. “Anyhow,” she added putting the clipping back into her purse, “this is a private thing right now, and I’d appreciate it if you wouldn’t make it the subject of one of your frequent tête-à-têtes.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Okay. If that’s the way you want it,” he said, standing up. “See you later then. Congratulations on the sale. Oh,” he said, stopping at the door. “Heard you’re going out to dinner tonight to celebrate.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes,” she said, and then held her breath. If Stephen had invited him along … ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Stephen asked me to go, but I have an appointment in Middletown. I’m meeting with the key investors in the new Sandburg Mall. Might be something big in it for us.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’m surprised Stephen didn’t worm his way out of our dinner date to go along with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He mentioned it,” Jason said, “but I wouldn’t permit it. I don’t want my sister neglected,” he added, smiling. “Especially after she’s made such a killing on the real estate market.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("At that moment she hated him for making it sound as though he had given her her husband for the evening, out of the goodness of his heart. Did he think he had that much control? Maybe he did, Cynthia thought sadly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Thank you, Jason. Thank you for thinking of me,” she said. It came out surprisingly sarcastic, and she thought she sounded more like Jason than herself. It only brought a wider smile to his confident face.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That prospectus is in my office,” he repeated, and left her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She sat back and stared at the closed door. She didn’t understand why, but she felt terribly frustrated when she knew she should be excited and happy. The resulting anxiety drove her back to the old news clipping and the picture of Karla Hoffman. She hadn’t had it in her possession that long, but she felt as though it had become an important part of her. She was being drawn to it by more than mere curiosity. It was eerie, but fascinatingly so. Jason was wrong to brush it off so quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As she studied the picture now, she thought that Karla Hoffman’s expression had somehow changed. It was a ridiculous idea. She knew that. But the smile around the dead woman’s eyes … was that there before?")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She went to Jason’s office to read the prospectus on the time-sharing investment. She wanted to be critical about it; she was in that kind of mood. But after she read it she found she couldn’t be. She had to agree with him when he talked about the location, the growing population and the investments in developments, businesses, restaurants and the malls in the area. He behaved as though it was important to him that she approved, so she put aside the indignation she had felt for being ignored.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Before she left Jason’s office Stephen buzzed to remind her that she had to take him to Al’s Foreign Car Service Station, where he had left his 380SL.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I have to leave early,” she said. “I want to pick up some stockings and some things at the drugstore.” He wasn’t happy about it, but he left when she wanted to.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Why did you have to ask Jason to go out with us?” she asked him as soon as she pulled away from the agency. He didn’t respond, and when she turned to him he looked puzzled. “I thought it was important for us to be alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t know what you’re talking about, Cyn. I didn’t ask him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He knew about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I mentioned it to him, but I didn’t ask him along.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He said you did. The only reason he’s not joining us is because he has some business meeting.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He must have been teasing you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Don’t you think that after all these years I would know when my brother is joking?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, I didn’t ask him along,” Stephen said emphatically. “When I see him tomorrow I’ll find out what he was up to.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No,” she said. “I don’t want to start something. He’ll realize that it was bothering me that you might have asked him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“So?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Just forget it. I want to be happy. I should be happy,” she added, as though she had to convince herself more than she had to convince him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“All right. If that’s what you want. It’s not that important anyway.” He sat back and closed his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When she looked at him she thought, Stephen is changing. He’s becoming more and more like Jason. It wasn’t always like this, she thought, and she remembered. She remembered Stephen when they first met, how physically vibrant he was. She laughed at the memories of their one-on-one basketball games, the way he played tennis with a racket in each hand, the time they went bowling at the Kiamesha Lanes and she threw five gutter balls.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Jason had little in common with Stephen then, and he never accompanied them anywhere. It was only after Stephen and she were engaged that Jason paid any attention to him. She thought they weren’t going to get along. They were so unalike in manner and dress, and they had few, if any, common interests.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She couldn’t help believing that her father’s death had been the catalyst to bring Jason and Stephen together. In those days she was happy they were getting along so well. She was afraid for the business. Her father had been such a strong personality. She dared not say it, but she had real doubts that Jason could maintain the clientele her father had developed. So much of what they did depended on warm personal contact with people, and Jason was far too standoffish. He needed Stephen because Stephen was so outgoing and personable.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("For her to have come between them then would have been wrong, she thought; but now she believed that Jason had taken advantage of her compassion and understanding. He began to make greater and greater demands on Stephen’s time until he turned him into the same sort of workaholic.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But she couldn’t help feeling pity for Jason, even though it would kill him to know it. In so many ways he had been dependent upon their father. He lived with him up until the day he died. He was there for more than fifteen years, moving in soon after their mother had died. Suddenly he was alone again, and she thought it would be cruel to cut Stephen away from him just when he needed a brother the most. So she tried to ignore the hours he spent at Jason’s house, the trips that they had to take together, the long phone conversations they had on weekends or on evenings when the business end of their lives should have been put aside.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("For Stephen there was something else. She was there; their marriage was there; their lives were there to be developed and enjoyed. But this was not so for Jason. What bothered her and what she knew bothered many other people was Jason’s failure to develop any romantic interests. At first she thought he saw himself as above the pursuit. It was true she couldn’t imagine Jason frequenting singles bars, and he had no other close male friends beside Stephen.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She suspected that his occasional weekends in the city had something to do with an affair or two, even though he never talked about it. She thought he had a need to be secretive. It was simply another one of his peculiarities. Occasionally, when he did describe a play he had seen or a place he had been to, she got the distinct impression he had been with someone else. Of course she asked Stephen about it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Why do you suppose he hasn’t found anyone or developed a relationship?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Your brother’s too damn particular,” he said. “He’s had many good opportunities to go out with nice women, but he always finds something wrong with them. Usually it has to do with their personalities or their mentalities. I’ve given up trying to find him someone. Remember how your Uncle Morris tried to fix him up with the mayor’s secretary in Philly? He wouldn’t even go on a blind date; he thought that was too juvenile.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What does he do in New York?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He doesn’t tell me.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She didn’t believe him, but she didn’t pursue it. It was like coming to a door, and knowing if you opened it, there would be something terrible behind it. Why open it if you didn’t have to? Instead she accepted the fact that Jason was too particular, and she even pitied the woman he might eventually marry; but she couldn’t help wishing that he would find someone to take up some of his endless energy and provide him with new interests.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She dropped Stephen off at the service station and went on to do her shopping. They had determined that they would go to dinner early because they were both feeling hungry. He said he didn’t have much opportunity to eat at the track. The lunch was more talk than food, and he couldn’t get what he wanted anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("By the time she arrived at home Stephen had gotten there before her. He greeted her at the door.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Ralph Hillerman called.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh. What did he want?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t know. I didn’t speak to him. He left his name on the answering machine.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Thanks.” She was still reluctant to tell him about Karla Hoffman.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Think it’s about the house sale?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t know. I’ll call him and see.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Right. I’m going to shower and dress.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’ll be right behind you,” she said, and went into the den to call Ralph.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I must be crazy,” he said, “talking about this, but you got me thinking about it. You know how it is … once something gets stirred up in your mind. …”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What did you remember?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, in those days, makeup, cosmetics, beauticians … the whole thing was suspect to my grandmother. She thought women who tampered with their natural looks were floozies.” He laughed. “And women who smoked were loose.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“So?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I remembered a comment she made about Karla Hoffman. I remembered it because it stuck with me for a long time after her death and the scandal. I used to spend a lot of time with my grandmother … do errands for her, talk with her.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What did she say?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“She said she always knew that woman would have a terrible end. She based her prediction on the fact that she had dyed her hair.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Dyed her hair?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yeah. Like you. I just thought about it when Marge asked me about you. She always wants to know how you look and what you’re wearing. She thinks you should have been a model. So anyway …”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Cynthia had taken the old news clipping out of her pocketbook and placed it before her with the picture up.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You mean Karla wasn’t light haired?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No, no. She was a dark brunette, like you were before. Don’t know why she did it. I guess people thought blondes had more fun, even in those days. Maybe she thought she was another Jean Harlow. A lot of women tried to be.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“She was a brunette and turned herself into a blonde?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yeah. I don’t know if that means anything important to you, but I figured I’d tell you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Thanks, Ralph. I’ll call you after I speak to the Bloomfields again.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Her face was still flushed for a few moments after she hung up. She stood there looking at the photograph and thinking so hard that she didn’t hear Stephen come to the doorway. He was wearing only a towel, but he hadn’t gone into the shower yet. He studied her for a few moments before speaking.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What is it?” he asked. She nearly jumped.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What?” Instinctively she covered the old clipping with her hand as she turned to him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Something to do with the sale?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well … anything wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No,” she said. She didn’t add anything else for a few moments. Instead she thought how it was because of Stephen, because of the way he looked at and appreciated that model on the magazine cover, that she had dyed her hair. What had been Karla Hoffman’s reason? Was it what Ralph thought … an infatuation with a movie star? Or was she trying to rekindle the flames of her romance, too? “No, it’s nothing,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Good. I was looking for the hair blower.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, it’s in the blue bathroom.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Right.” He started to turn away and stopped. “Are you sure everything is okay? You look disturbed.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She started to lift her hand from the old photograph with the intention of talking about it, but it was as though her hand were glued to the document. She couldn’t raise it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No,” she said quickly. “I’m just hungry.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Me, too.” He smiled and went off.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As soon as he was gone she was able to uncover the photograph. For a moment she just stared down at it. That smile she had seen around Karla Hoffman’s eyes … was it still there? Had she imagined it? Perhaps she was simply imposing her own feelings into the picture, projecting her own expressions into Karla Hoffman.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It gave her second thoughts. Maybe Ralph Hillerman’s grandmother was right … maybe it was wrong to stir up the victims of violent death. She would think hard before she would go any further with this mania for learning all she could about the Karla Hoffman story. She put the clipping back into her purse and closed it. When she entered the bedroom, she heard Stephen singing in the shower. He hadn’t done that for some time now.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Maybe it’s all right, she thought. Maybe everything is a product of my idle imagination. She decided that she had better get a hold of herself and, like Jason, be more Palmeresque. It had its advantages.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She lost herself in her preparations for going out to dinner and thought of Karla Hoffman only for a fleeting moment when she had the strange sensation there was another presence in the room. She looked into her vanity mirror quickly and was surprised at the look on her own face. It was the same expression worn by Karla in the photograph.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d16f3e62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/978150408440623.vue
// module id = 75
// module chunks = 0